import api from "./api";

/* 训练计划api */
export const planList = params => {
  return api('post', `/v1/management/campPlan/query`, params);
};

export const planDetail = id => {
  return api('get', `/v1/management/campPlan/details/${id}`);
};

export const planAdd = params => {
  return api('post', `/v1/management/campPlan/add`, params);
};

export const courseSelect = name => {
  return api('get', `/v1/management/campPlan/courseSelect/${name}`);
};

export const deletePlan = id => {
  return api('delete', `/v1/management/campPlan/delete/${id}`);
};

export const planEdit = params => {
  return api('post', `/v1/management/campPlan/update`, params);
};

/* 抽奖api */
export const lotteryList = params => {
  return api('post', `/v1/management/campPrize/query`, params);
};

export const lotteryPoolAdd = params => {
  return api('post', `/v1/management/campPrize/addPool`, params);
};

export const lotteryPrizeAddAndEdit = params => {
  return api('post', `/v1/management/campPrize/addOrUpdatePrizeInfo`, params);
};

export const lotteryPrizeDetails = id => {
  return api('get', `/v1/management/campPrize/details/${id}`);
};

export const lotteryPrizeDelete = (poolId, prizeId) => {
  return api('delete', `/v1/management/campPrize/deletePrize/${poolId}/${prizeId}`);
};

export const lotteryPoolDelete = poolId => {
  return api('delete', `/v1/management/campPrize/deletePool/${poolId}`);
};

export const lotteryPoolEdit = params => {
  return api('post', `/v1/management/campPrize/updatePool`, params);
};

export const lotteryExportEnrollmentList = poolId => {
  return api('get', `/v1/management/campPrize/exportEnrollmentList/${poolId}`, {}, {
    responseType: "blob",
  });
};

/* campset api */
export const campSetList = params => {
  return api('post', `/v1/management/camp/query`, params);
};

export const campSetAdd = params => {
  return api('post', `/v1/management/camp/add`, params);
};

export const campSetEdit = params => {
  return api('post', `/v1/management/camp/update`, params);
};

export const campSetWithdraw = id => {
  return api('get', `/v1/management/camp/revocation/${id}`);
};

export const campSetDetails = id => {
  return api('get', `/v1/management/camp/details/${id}`);
};

export const campSetRelease = id => {
  return api('get', `/v1/management/camp/publish/${id}`);
};
export const campSetCancelRelease = id => {
  return api('get', `/v1/management/camp/unpublished/${id}`);
};

export const campSetRemoveShelf = id => {
  return api('get', `/v1/management/camp/offline-camp/${id}`);
};

export const campSetExportEnrollmentList = id => {
  return api('get', `/v1/management/camp/exportEnrollmentList/${id}`, {},
    {
      responseType: "blob",
    });
};

export const campSetPlanSelect = params => {
  return api('get', `/v1/management/camp/planSelect`, params);
};

export const campSetPrizeSelect = params => {
  return api('get', `/v1/management/camp/prizeSelect`, params);
};

/* 商品api */

export const campGoodsList = params => {
  return api('post', `/v1/management/equipment-camp/list`, params);
};

export const campSaveGoods = params => {
  return api('post', `/v1/management/equipment-camp/saveEquipment`, params);
};

export const queryByCampid = campId => {
  return api('get', `/v1/management/equipment-camp/equipmentByCampId/${campId}`);
};

export const prizeSelectWithCurrent = params => {
  return api('get', `/v1/management/camp/prizeSelectWithCurrent`, params);
};
